/** Sub-navigation sections within the Configuration page. */
export interface ConfigSection {
  id: string
  label: string
  /** Standalone sections render above the divider that separates the grouped ones. */
  standalone?: boolean
}

export const CONFIG_SECTIONS: readonly ConfigSection[] = [
  { id: 'agents-models', label: 'Agents & Models' },
  { id: 'variables', label: 'Variables' },
  { id: 'agent-rules', label: 'Agent rules' },
  { id: 'sop', label: 'SOP' },
]

export const DEFAULT_CONFIG_SECTION = 'agents-models'
